import InvoiceRow from './InvoiceRow';

export default InvoiceRow;
